/* eslint-disable max-len */
import { IWellnessPlanBillingPageData } from "./wellness-plan-by-user.interface";
import WELLNESS_PLANS_BY_USER from "./wellness-plan-by-user.query";
import { useLazyQuery } from "@apollo/client";

export function markPetsShownForModal(modalKey: string, petIds: string[]) {
  const stored = localStorage.getItem("modalsShownForPets");
  const parsed = stored ? JSON.parse(stored) : {};

  parsed[modalKey] = [...new Set([...(parsed[modalKey] || []), ...petIds])];

  localStorage.setItem("modalsShownForPets", JSON.stringify(parsed));
}

export function getPetsShownForModal(modalKey: string) {
  const stored = localStorage.getItem("modalsShownForPets");

  if (!stored) return [];
  const parsed = JSON.parse(stored);

  return parsed[modalKey] || [];
}

export function filterPetsForModal(modalKey: string, petIds: string[]) {
  const petsShown = getPetsShownForModal(modalKey);

  return petIds.filter((petId) => !petsShown.includes(petId));
}

const useWellnessPlansByUser = () => {
  const [getWellnessPlansForUser, { data, loading, error }] =
    useLazyQuery<IWellnessPlanBillingPageData>(WELLNESS_PLANS_BY_USER, {
      fetchPolicy: "network-only",
      nextFetchPolicy: "network-only",
    });

  const getWellnessPlansByUser = () => {
    getWellnessPlansForUser();
  };

  const wellnessPlansByUser = data ? (data.getWellnessPlansForUser?.wellnessPlanByUser ?? []) : null;

  return {
    data: wellnessPlansByUser,
    recentlyCancelWellnessPlanByUser: data?.getWellnessPlansForUser?.recentlyCancelWellnessPlanByUser,
    loading,
    error,
    getWellnessPlansByUser,
  };
};

export default useWellnessPlansByUser;
